import { makeStyles } from "tss-react/mui";

interface StyleProps {
  isHomePage?: boolean;
  isGenerating?: boolean;
}

export const useStyles = makeStyles<StyleProps>()(
  (theme, { isHomePage = false, isGenerating = false }) => ({
    container: {
      position: "fixed",
      bottom: isHomePage ? "auto" : 0,
      top: isHomePage ? 50 : "auto",
      left: 0,
      right: 0,
      backgroundColor: theme.palette.background.paper,
      borderTop: isHomePage ? "none" : `1px solid ${theme.palette.divider}`,
      borderBottom: isHomePage ? `1px solid ${theme.palette.divider}` : "none",
      padding: theme.spacing(2),
      zIndex: 100,
      cursor: isGenerating ? "not-allowed" : "pointer",
      opacity: isGenerating ? 0.7 : 1,
    },
    content: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1.5),
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(3),
      padding: theme.spacing(1.5, 2),
      border: `1px solid ${theme.palette.divider}`,
      transition: "all 0.2s",

      "&:hover": {
        borderColor: isGenerating
          ? theme.palette.divider
          : theme.palette.primary.main,
        boxShadow: isGenerating
          ? "none"
          : `0 0 0 1px ${theme.palette.primary.main}`,
      },
    },
    imagePreviewsWrapper: {
      display: "flex",
      gap: theme.spacing(0.5),
      flexShrink: 0,
      alignItems: "center",
    },
    imagePreview: {
      position: "relative",
      width: 32,
      height: 32,
      borderRadius: theme.spacing(0.75),
      overflow: "hidden",
      border: `1px solid ${theme.palette.divider}`,
    },
    previewImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    moreImages: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 32,
      height: 32,
      borderRadius: theme.spacing(0.75),
      backgroundColor: theme.palette.action.hover,
      fontSize: "0.75rem",
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    input: {
      flex: 1,
      border: "none",
      outline: "none",
      fontSize: "1rem",
      backgroundColor: "transparent",
      color: theme.palette.text.primary,
      cursor: isGenerating ? "not-allowed" : "pointer",

      "&::placeholder": {
        color: theme.palette.text.secondary,
      },

      "&:read-only": {
        cursor: isGenerating ? "not-allowed" : "pointer",
      },

      "&:disabled": {
        color: theme.palette.text.disabled,
      },
    },
  })
);
